export default {
      id: "ic_system_laptop-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_system_laptop-usage",
      toString: function () {
        return this.url;
      }
    }